
    import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator';

    @Component
    export default class OptionsFieldsString extends Vue {
        @Prop() value;
        @Prop() option;

        @Emit('input')
        setValue(event) {
            return event.target.value;
        }
    }
